import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';
import { ExpenseReceiptLink } from '../../utils/expenseReceipt';

const ExpenseModal = ({ isOpen, setIsOpen, editExpense = null, fetchExpenses }) => {
    // const categoryOptions = [
    //     { value: 'category1', label: 'Category 1' },
    //     { value: 'category2', label: 'Category 2' },
    //     { value: 'category3', label: 'Category 3' },
    // ];
    const token = decryptToken("accessToken") || ""
    const [categoryOptions, setCategoryOptions] = useState([]);
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    // const customerOptions = [
    //     { value: 'customer1', label: 'Customer 1' },
    //     { value: 'customer2', label: 'Customer 2' },
    //     { value: 'customer3', label: 'Customer 3' },
    // ];
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedType, setSelectedType] = useState(""); // could be "business" or "personal"
    // or 'personal' as default


    const [formData, setFormData] = useState({
        date: new Date().toISOString().split('T')[0],
        receipt: '',
        category: '',
        amount: '',
        invoiceNumber: '',
        notes: '',
        customer: '',
        user_id: isLoggedIn.main_id,
        user_name: isLoggedIn.full_name,
        expenseType: ""
    });
    const url = process.env.REACT_APP_LINK

    const [isAddCategoryModalOpen, setIsAddCategoryModalOpen] = useState(false);
    const [newCategory, setNewCategory] = useState({
        catgeory: '', description: '',
        user_id: isLoggedIn.main_id,
        user_name: isLoggedIn.full_name
    });

    useEffect(() => {
        if (editExpense) {
            setFormData({
                date: editExpense.date || '',
                receipt: '',
                category: editExpense.category
                    ? { label: editExpense.category, value: editExpense.category }
                    : '',
                amount: editExpense.amount || '',
                invoiceNumber: editExpense.invoiceNumber || '',
                notes: editExpense.notes || '',
                customer: editExpense.customer
                    ? { label: editExpense.customer, value: editExpense.customer }
                    : '',
                user_id: isLoggedIn.main_id,
                user_name: isLoggedIn.full_name
            });
            setSelectedType(editExpense.expenseType)
        }
    }, [editExpense]);



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setFormData((prev) => ({ ...prev, receipt: e.target.files[0] }));
    };

    const handleSelectChange = (selectedOption, action) => {
        setFormData((prev) => ({ ...prev, [action.name]: selectedOption }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.date || !formData.amount || !formData.category) {
            toast.error('Date, category, and amount are required.');
            return;
        }
        try {
            const data = new FormData();
            data.append('date', formData.date);
            data.append('expenseType', selectedType);
            data.append('receipt', formData.receipt);
            data.append('category', formData.category?.value || '');
            data.append('amount', formData.amount);
            data.append('invoiceNumber', formData.invoiceNumber);
            data.append('notes', formData.notes);
            // data.append('customer', formData.customer?.value || '');
            data.append('customer', formData.customer?.label || ''); // for name
            data.append('customerId', formData.customer?.value || ''); // for ID (send this to backend)
            data.append('user_id', isLoggedIn.main_id);
            data.append('user_name', isLoggedIn.full_name);

            const urlmain = editExpense
                ? `${url}/api/expenses/change/${editExpense.id}`
                : `${url}/api/expenses`;
            const method = editExpense ? 'PUT' : 'POST';

            const response = await fetch(urlmain, {
                method,
                body: data,
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || 'Something went wrong');
            }
            fetchExpenses?.();

            toast.success(editExpense ? 'Expense updated successfully!' : 'Expense created successfully!');
            setFormData({
                date: '',
                receipt: '',
                category: '',
                amount: '',
                invoiceNumber: '',
                notes: '',
                customer: '',
                user_id: isLoggedIn.main_id,
                user_name: isLoggedIn.full_name
            })
            setIsOpen(false);
        } catch (error) {
            console.error('Error:', error.message);
            toast.error(`Error: ${error.message}`);
        }
    };

    const handlecategoryExpense = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${url}/expense-category`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    catgeory: newCategory.catgeory,
                    description: newCategory.description,
                    user_id: isLoggedIn.main_id,
                    user_name: isLoggedIn.full_name
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to add category");
            }

            // ✅ Add to dropdown options only
            const newOption = {
                value: newCategory.catgeory,
                label: newCategory.catgeory,
            };
            setCategoryOptions((prev) => [...prev, newOption]);

            // ✅ Clear modal inputs
            setNewCategory({ catgeory: '', description: '' });
            toast.success('Category added successfully!');
            setIsAddCategoryModalOpen(false);
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        }
    };



    const fetchCategories = async () => {
        try {
            const response = await fetch(`${url}/expense-category/all/${isLoggedIn.main_id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const data = await response.json();
            const formattedData = data.map((item) => ({
                value: item.catgeory,
                label: item.catgeory,
            }));
            setCategoryOptions(formattedData);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };


    const fetchCustomer = async () => {
        try {
            const response = await fetch(`${url}/api/customer/all/${isLoggedIn.main_id}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            const data = await response.json();
            const formattedData = data.map((item) => ({
                value: item.id,
                label: item.customerName,
            }));
            setCustomerOptions(formattedData);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };


    const handleAddCategory = () => {
        if (newCategory.catgeory && newCategory.description) {
            categoryOptions.push({ value: newCategory.catgeory, label: newCategory.catgeory });
            setIsAddCategoryModalOpen(false);
            setNewCategory({ catgeory: '', description: '' });
        }
    };



    useEffect(() => {
        fetchCategories();
        fetchCustomer();
    }, []);

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="oms-modal-title">Expense Details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group single-checkbox-select">
                        <label className="checkbox-title">Expense Type</label>
                        <div className="checkbox-options">
                            <label className={`checkbox-option ${selectedType === "Liability" ? "active" : ""}`}>
                                <input
                                    type="checkbox"
                                    checked={selectedType === "Liability"}
                                    onChange={() =>
                                        setSelectedType((prev) => (prev === "Liability" ? "" : "Liability"))
                                    }
                                />
                                Liability
                            </label>
                            <label className={`checkbox-option ${selectedType === "Asset" ? "active" : ""}`}>
                                <input
                                    type="checkbox"
                                    checked={selectedType === "Asset" || selectedType === "Assest"}
                                    onChange={() =>
                                        setSelectedType((prev) => (prev === "Asset" ? "" : "Asset"))
                                    }
                                />
                                Asset
                            </label>
                        </div>
                    </div>



                    <div className="oms-form-group">
                        <label htmlFor="date">Date</label>
                        <input type="date" id="date" name="date" value={formData.date} onChange={handleChange} />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="receipt">Attach Receipt</label>

                        {/* Existing receipt preview */}
                        {editExpense && editExpense.receipt && (
                            <div
                                style={{
                                    backgroundColor: '#f9f9f9',
                                    padding: '10px',
                                    marginBottom: '8px',
                                    border: '1px solid #ccc',
                                    borderRadius: '5px',
                                }}
                            >
                                <span style={{ fontWeight: 'bold' }}>Previously Uploaded:</span>{' '}
                                <ExpenseReceiptLink filename={editExpense.receipt} label="View Receipt" />
                            </div>
                        )}

                        {/* Upload new file */}
                        <input
                            type="file"
                            id="receipt"
                            name="receipt"
                            accept=".jpeg,.jpg,.png,.webp,.pdf"
                            onChange={handleFileChange}
                        />
                    </div>

                    <div className="oms-form-group">
                        <label>Category</label>
                        <Select
                            name="category"
                            options={categoryOptions}
                            value={formData.category}
                            onChange={(option) => handleSelectChange(option, { name: 'category' })}
                        />
                        <button type="button" className="oms-add-button" onClick={() => setIsAddCategoryModalOpen(true)}>
                            Add new category
                        </button>
                    </div>

                    <div className="oms-form-group">
                        <label>Amount</label>
                        <input type="number" name="amount" value={formData.amount} onChange={handleChange} />
                    </div>
                    <div className="oms-form-group">
                        <label>Invoice Number</label>
                        <input type="text" name="invoiceNumber" value={formData.invoiceNumber} onChange={handleChange} />
                    </div>
                    <div className="oms-form-group">
                        <label>Notes</label>
                        <textarea name="notes" value={formData.notes} onChange={handleChange}></textarea>
                    </div>
                    <div className="oms-form-group">
                        <label>Customer</label>
                        <Select
                            name="customer"
                            options={customerOptions}
                            value={formData.customer}
                            onChange={(option) => handleSelectChange(option, { name: 'customer' })}
                        />
                        <Link to="/add-customer">
                            <button type="button" className="oms-add-button">Add new customer</button>
                        </Link>
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        <button type="submit">{editExpense ? 'Update' : 'Submit'}</button>
                    </div>
                </form>
            </div>

            {/* Add Category Modal */}
            {isAddCategoryModalOpen && (
                <div className="custom-modal-overlay" onClick={() => setIsAddCategoryModalOpen(false)}>
                    <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                        <h2>Add New Category</h2>
                        <form className="oms-modal-form" >
                            <div className="oms-form-group">
                                <label>Category Name</label>
                                <input
                                    type="text"
                                    name='catgeory'
                                    value={newCategory.catgeory}
                                    onChange={(e) => setNewCategory({ ...newCategory, catgeory: e.target.value })}
                                />
                            </div>
                            <div className="oms-form-group">
                                <label>Description</label>
                                <input
                                    type="text"
                                    name='description'
                                    value={newCategory.description}
                                    onChange={(e) => setNewCategory({ ...newCategory, description: e.target.value })}
                                />
                            </div>
                            <div className="oms-form-actions">
                                <button type="button" onClick={() => setIsAddCategoryModalOpen(false)}>Cancel</button>
                                <button type="button" onClick={handlecategoryExpense} >Save Category</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ✅ Toastify container */}

        </div>
    );
};

export default ExpenseModal;
